import { formTypes } from 'lib/constants/forms/formTypes';
import { ia } from 'lib/helpers/utility';

export const handleForms = (value) => {
  const forms = [];
  if (ia(value?.data?.forms)) {
    value?.data?.forms?.forEach((form) => {
      const matchedForm = formTypes?.find(
        (otherForm) => otherForm?.id === form?.id || otherForm?.altId === form?.id
      );
      if (matchedForm) {
        forms.push(matchedForm?.name);
      }
    });
  }
  if (ia(value?.form_ids)) {
    value?.form_ids?.forEach((formId) => {
      forms.push(formId?.label);
    });
  }
  return forms;
};

export const handleFormsStatus = (value, completed) => {
  const resultArray = [];

  value?.data?.forms
    .filter((form) => form?.completed === completed)
    .forEach((form) => {
      const matchedForm = formTypes?.find(
        (otherForm) => otherForm?.id === form?.id || otherForm?.altId === form?.id
      );
      if (matchedForm) {
        resultArray.push(matchedForm?.name);
      }

      const matchedLabel = value?.form_ids?.find((f) => f.value === form.id);
      if (matchedLabel) {
        resultArray.push(matchedLabel?.label);
      }
    });

  return resultArray;
};

export const getCountOfForms = (value) => {
  if (!value?.data?.forms || !ia(value.data.forms)) {
    return '-';
  }
  let completedCount = 0;

  value?.data?.forms.forEach((form) => {
    if (form.completed) {
      completedCount++;
    }
  });
  return `${completedCount}/${value?.data?.forms?.length}`;
};
